module.exports = __webpack_public_path__ + "static/media/youtube.f8754225.svg";